import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

// TODO: DREGAB-12525 - fixing scroll should solve following overflow fix
export const StyledPrescriptionsHistory = styled(StyledFlex)`
   min-width: 800px;
`;
StyledPrescriptionsHistory.displayName = 'StyledPrescriptionsHistory';
